import { Settings } from "../../Settings";
import { ButtonColors, Panel } from "./panel";

const transparentButtonColor: ButtonColors = {
    backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgba(255, 0, 0, 0.0), rgb(0, 0, 0))",
    linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%"
};


export class DefaultTransparentPanel extends Panel
{
    public override ConstructHtml(): void {
        if (Settings.EnablePanelWithSettings)
        {
            this.ConstructHtmlWithSettingsBtn()
            return;
        }
    }
    protected override ButtonBackground(): ButtonColors
    {
        return transparentButtonColor;
    }
}